import { Link } from "react-router-dom";
import { Mail, Phone } from "lucide-react";
import { SignupForm } from "@/components/EmailSignup";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_wellness-shots/artifacts/dibvmg73_kens%20gold.png";

function FooterBrand() {
  return (
    <div data-testid="footer-brand">
      <Link to="/" className="flex items-center gap-2 mb-4">
        <img src={LOGO_URL} alt="Ken's Gold" className="w-8 h-8 rounded-full object-cover" />
        <span className="font-playfair text-lg">
          <span className="text-white font-semibold">Ken's</span>{" "}
          <span className="text-gold-light font-bold">Gold</span>
        </span>
      </Link>
      <p className="text-sm leading-relaxed opacity-80">
        Nature's finest ingredients — Organic Ginger, Organic Lemon, Raw Honey, Organic Apple Cider Vinegar & Organic Green Tea — bottled for your daily wellness ritual.
      </p>
    </div>
  );
}

function FooterExplore() {
  return (
    <div data-testid="footer-explore">
      <h4 className="text-xs font-bold tracking-widest text-gold-light uppercase mb-4">Explore</h4>
      <ul className="space-y-3">
        <li><Link to="/" className="text-sm hover:text-gold">Home</Link></li>
        <li><Link to="/shop" className="text-sm hover:text-gold">Shop</Link></li>
        <li><Link to="/benefits" className="text-sm hover:text-gold">Ingredients & Benefits</Link></li>
        <li><Link to="/crafting-storage" className="text-sm hover:text-gold" data-testid="footer-crafting-link">Crafting &amp; Storage</Link></li>
        <li><Link to="/wellness" className="text-sm hover:text-gold">Wellness Guide</Link></li>
        <li><Link to="/origin" className="text-sm hover:text-gold">Our Story</Link></li>
      </ul>
    </div>
  );
}

function FooterContact() {
  return (
    <div data-testid="footer-contact">
      <h4 className="text-xs font-bold tracking-widest text-gold-light uppercase mb-4">Get in Touch</h4>
      <ul className="space-y-3">
        <li className="flex items-center gap-2 text-sm">
          <Mail size={16} className="text-gold-light" />orders@kensgold.com
        </li>
        <li className="flex items-center gap-2 text-sm">
          <Phone size={16} className="text-gold-light" />Contact us to place your order
        </li>
      </ul>
      <p className="text-xs mt-4 opacity-60">
        We respond to all orders within 24 hours. All products are freshly made with raw, organic ingredients.
      </p>
    </div>
  );
}

function FooterSignup() {
  return (
    <div className="border-b border-white/10" data-testid="footer-signup">
      <div className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div>
          <h3 className="font-playfair text-2xl font-bold text-white mb-2">Get 10% Off Your First Order</h3>
          <p className="text-sm opacity-70">Join the Ken's Gold circle for wellness tips, new blends, and your welcome discount.</p>
        </div>
        <SignupForm dark prefix="footer-signup" />
      </div>
    </div>
  );
}

export default function Footer() {
  return (
    <footer className="footer" data-testid="footer">
      <FooterSignup />
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <FooterBrand />
          <FooterExplore />
          <FooterContact />
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 text-center text-xs opacity-50">
          &copy; 2026 Ken's Gold Wellness. All rights reserved. Made with love and raw ingredients.
        </div>
      </div>
    </footer>
  );
}
